import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { isDigit3mimrri4wkzop as isDigit } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/charJs.mjs';
import {
  _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx,
  Char19o2r8palgjof as Char,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { setOf45ia9pnfhe90 as setOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  startsWith1bgirhbedtv2y as startsWith,
  removePrefix279df90bhrqqg as removePrefix,
  substringBefore3n7kj60w69hju as substringBefore,
  substringAfter1hku067gwr5ve as substringAfter,
  contains2el4s70rdq4ld as contains,
  padStart36w1507hs626a as padStart,
  trimEndvvzjdhan75g as trimEnd,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isCharSequence1ju9jr1w86plq as isCharSequence } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  reversed3umwqsxpi431x as reversed,
  chunked3v1tthtda414w as chunked,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/_Strings.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  reversed22y3au42jl32b as reversed_0,
  joinToString1cxrrlmo0chqs as joinToString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { numberToLong2pakxeg38estk as numberToLong } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { roundToInt1ue8x8yshtznx as roundToInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/math/math.mjs';
import { charArrayOf27f4r3dozbrk1 as charArrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/arrays.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function commaString(_this__u8e3s4) {
  // Inline function 'kotlin.text.filter' call
  var tmp0 = toStringNoExponential(_this__u8e3s4);
  // Inline function 'kotlin.text.filterTo' call
  var destination = StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$();
  var inductionVariable = 0;
  var last = charSequenceLength(tmp0);
  if (inductionVariable < last)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var element = charSequenceGet(tmp0, index);
      if (isDigit(element) || setOf([new (Char())(_Char___init__impl__6a9atx(46)), new (Char())(_Char___init__impl__6a9atx(45))]).contains_aljjnj_k$(new (Char())(element))) {
        destination.append_58al37_k$(element);
      }
    }
     while (inductionVariable < last);
  var clean = destination.toString();
  var negative = startsWith(clean, _Char___init__impl__6a9atx(45));
  var digits = removePrefix(clean, '-');
  // Inline function 'kotlin.text.reversed' call
  var this_0 = substringBefore(digits, _Char___init__impl__6a9atx(46));
  var tmp = toString(reversed(isCharSequence(this_0) ? this_0 : THROW_CCE()));
  var preDecimal = joinToString(reversed_0(chunked(tmp, 3, commaString$lambda)), ',');
  var postDecimal = substringAfter(digits, _Char___init__impl__6a9atx(46), '');
  var result = contains(digits, _Char___init__impl__6a9atx(46)) ? preDecimal + '.' + postDecimal : preDecimal;
  return negative ? '-' + result : result;
}
function toStringNoExponential(_this__u8e3s4) {
  var negative = _this__u8e3s4 < 0.0;
  // Inline function 'kotlin.math.abs' call
  var abs = Math.abs(_this__u8e3s4);
  var preDecimal = numberToLong(abs).toString();
  var r = abs % 1;
  if (r === 0.0)
    return negative ? '-' + preDecimal : preDecimal;
  var availableDigits = 10 - preDecimal.length | 0;
  // Inline function 'kotlin.math.pow' call
  var tmp$ret$1 = Math.pow(10.0, availableDigits);
  var postDecimal = roundToInt(r * tmp$ret$1);
  var result = postDecimal === 0 ? preDecimal : preDecimal + '.' + trimEnd(padStart(postDecimal.toString(), availableDigits, _Char___init__impl__6a9atx(48)), charArrayOf([_Char___init__impl__6a9atx(48)]));
  return negative ? '-' + result : result;
}
function commaString$lambda(it) {
  return reversed(it);
}
//region block: exports
export {
  commaString as commaStringeuj84z632mms,
};
//endregion

//# sourceMappingURL=backspace.mjs.map
